/* eslint-disable @typescript-eslint/no-unused-expressions */
import { progressApi } from "utilities/Axios";
import { getExtractedPath } from "utilities/extractedPath";

const extractedPath = getExtractedPath();

export const getBubblesMeta = () => {
  return progressApi.get(`/UnityData/GetUnityBubbleMeta${extractedPath}`);
};

export const getBubblesData = () => {
  return progressApi.get(`/UnityData/GetUnityBubbleData${extractedPath}`);
  // return api.get("/Unity/GetUnityBubbleData?dateTime=2023-10-02T22%3A46%3A00.000");
};

export const updateBubblePosition = (data: any) => {
  return progressApi.post(`/Unity/UpdateBubbleCordinates${extractedPath}`, data);
};

export const getNotes = () => {
  return progressApi.get(`/UnityData/GetUnityNoteMeta${extractedPath}`);
};

export const getEquipment = (id: any) => {
  return progressApi.get(`/UnityData/GetEquipment${extractedPath}?id=${id}`);
};

export const getUnit = (id: any) => {
  return progressApi.get(`/UnityData/GetUnit${extractedPath}?id=${id}`);
};

export const getNote = (id: any) => {
  return progressApi.get(`Unity/GetNote${extractedPath}?id=${id}`);
};

export const getBubble = (id: any) => {
  return progressApi.get(`Unity/GetBubble${extractedPath}?id=${id}`);
};

export const downloadFile = (id: any) => {
  return progressApi.get(`/Unity/getFile${extractedPath}` + `?id=${id}`);
};

// Notes

export const createNote = (data: any) => {
  return progressApi.post(`/Unity/CreateNote${extractedPath}`, data);
};

export const updateNote = (data: any) => {
  return progressApi.post(`/Unity/UpdateNote${extractedPath}`, data);
};

export const deleteNote = (id: any) => {
  return progressApi.get(`/Unity/DeleteNote${extractedPath}` + `?id=${id}`);
};

// Bubbles

export const createBubble = (data: any) => {
  return progressApi.post(`/Unity/CreateBubble${extractedPath}`, data);
};

export const updateBubble = (data: any) => {
  return progressApi.post(`/Unity/UpdateBubble${extractedPath}`, data);
};

export const deleteBubble = (id: any) => {
  return progressApi.get(`/Unity/DeleteBubble${extractedPath}` + `?id=${id}`);
};

export const createWidget = (data: any) => {
  return progressApi.post(`/Unity/CreateUnityWidget${extractedPath}`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const updateWidget = (data: any) => {
  return progressApi.post(`/Unity/UpdateUnityWidget${extractedPath}`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const updateWidgetPosition = (data: any) => {
  return progressApi.post(`/Unity/UpdateUnityWidgetCordinates${extractedPath}`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const deleteWidget = (id: number) => {
  return progressApi.post(`/Unity/DeleteUnityWidget${extractedPath}` + `?id=${id}`);
};

export const getAllWidgets = () => {
  return progressApi.get(`/Unity/GetUnityWidgetList${extractedPath}`);
};

export const getWidget = (id: number) => {
  return progressApi.get(`/Unity/GetUnityWidget${extractedPath}` + `?id=${id}`);
};

export const getWidgetsMeta = () => {
  return progressApi.get(`/UnityData/GetUnityWidgetMeta${extractedPath}`);
};

export const getWidgetsData = () => {
  return progressApi.get(`/UnityData/GetUnityWidgetData${extractedPath}`);
};

export const getLabelsMeta = () => {
  return progressApi.get(`/Unity/GetUnityLabelMeta${extractedPath}`);
};

export const getLabel = (id: any) => {
  return progressApi.get(`Unity/GetLabel${extractedPath}?id=${id}`);
};

export const createLabel = (data: any) => {
  return progressApi.post(`/Unity/CreateLabel${extractedPath}`, data);
};

export const updateLabel = (data: any) => {
  return progressApi.post(`/Unity/UpdateLabel${extractedPath}`, data);
};

export const deleteLabel = (id: any) => {
  return progressApi.get(`/Unity/DeleteLabel${extractedPath}` + `?id=${id}`);
};

export const updateLabelPos = (data: any) => {
  return progressApi.post(`/Unity/UpdateLabelCordinates${extractedPath}`, data);
};